import { faMagnifyingGlass } from '@fortawesome/sharp-solid-svg-icons';

import './index.css';
export { SCAdvanceTable, SCAdvanceTableWithAutoSize } from './advance_table';
export { SCAdvanceTableInteractive } from './advance_table_interactive';
export { EnumTableFieldType, EnumTableSortDirection } from './types';
export type {
  AllowedIdField,
  BasicRecord,
  SCAdvanceTableInteractiveProps,
  SCAdvanceTableProps,
  TableColumn,
} from './types';
export { useAdvanceTableStateCache } from './use_table_state';

// patches ViewButton with EditButton/DeleteButton/etc in eone-ui
export function TableRowViewButton(OnClick: (id: string) => void, hide: string = '') {
  return {
    Title: 'View',
    Icon: faMagnifyingGlass,
    OnClick,
    Hidden: hide,
  };
}
